import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { PayoutDialog } from './payout.dialog';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '@environments/environment';

@Component({
  selector: 'withdraw-auto-banks',
  templateUrl: '../sharedTemplates/withdraw-auto-banks.html',
})
export class WithdrawAutoBanks implements OnInit {
  banksDatas: UntypedFormGroup;
  banksDatasRaw: any;

  bank: { BankId: number; Bank: string };
  // bankList = [];

  bankList: { BankId: number; Bank: string }[] = [];

  myControl = new UntypedFormControl();
  options;
  filteredOptions: Observable<string[]>;

  IsChangeActive = true;
  CurrentLimit;

  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper,
    public dialog: MatDialog
  ) {
    this.WithdrawBanks();

    this.getProcCustomerWithDrawRequestScreenResult();

    this.banksDatas = _FormBuilder.group({
      bankList: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
      accountNo: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
      nameSurname: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
      ssn: new UntypedFormControl({ value: '', disabled: false }),
      banksAmount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.min(50)]),
    });
  }

  ngOnInit() {
    this.banksDatas.valueChanges.subscribe(x => {
      this.banksDatasRaw = x;
      if (x.bankList == '') {
        this.WithdrawBanks();
      }
      this.bankList = this.bankList.filter(option => option.Bank !== null && option.Bank.toLowerCase().includes(x.bankList.toLowerCase()));
    });
  }

  ngAfterViewInit() {
    if (this._UiHelper.rightMenu) this._UiHelper.setRightMenu();

    this._UiHelper.setNavbarTitle('Withdraw', true);
  }

  WithdrawBanks() {
    this._ApiService.getWithdrawBanks().then(result => {
      this.bankList = result;
    });
  }

  openPayoutDialog(): void {
    const dialogRef = this.dialog.open(PayoutDialog, {
      width: environment.mobile ? '340px' : '500px',
      height: environment.mobile ? '345px' : '240px',
    });
    dialogRef.afterClosed().subscribe(result => {
      // //console.log('The dialog was closed',result);
    });
  }

  getProcCustomerWithDrawRequestScreenResult() {
    this._ApiService.getProcCustomerWithDrawRequestScreenResult(66).then(result => {
      // console.log('getProcCustomerWithDrawRequestScreenResult',result)
      this.IsChangeActive = result.IsChange;
      this.CurrentLimit = result.Amount;
    });
  }

  submitBanksData() {
    this._UiHelper.setLoadingDialog(true);

    this._ApiService.withdrawAutoBanks(this.banksDatasRaw, this.bankList[0].BankId).then(result => {
      this._UiHelper.setLoadingDialog(false);
      const translator = new TranslatePipe(this._LocalizationService);
      this._UiHelper.setLoadingDialog(false);
      if (result.code == '') {
        //return "error|System Error";
      } else {
        if (result.code == 'error') {
          this._UiHelper.errorSnackBar(result.message, '');
        } else if (result.code == 'errorcode') {
          let t_message = translator.transform(result.message, null);
          t_message = t_message + ' : ' + result.description;
          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'success') {
          //window.location = result.message;

          let t_message = translator.transform(result.message, null);
          t_message = t_message + result.description;
          this._UiHelper.successSnackBar(t_message, '');

          this.openPayoutDialog();

          if (this._UserHelper.customerUser.CustomerId) {
            this._ApiService.getClient2().then().catch();
          }
        }
      }
    });
  }
}
